import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { showTopbarInsideAction } from "../../store/actions";
import icon from "../../assets/images/not-permission.png"

const ErrorPermissionDenied = () => {
  document.title = "Permissão Negada";

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showTopbarInsideAction({}))
  }, [])

  return (
    <React.Fragment>
      <div className="page-content d-flex align-items-center justify-content-center page-erros">
        <Container fluid={true}>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center">
                <div>
                  <img height={180} src={icon}/>
                </div>
                <div>
                  <h4 className="mt-3">Desculpe!</h4>
                </div>
                <div>
                  <p className="mt-3">A transação que procura não está habilitada <br/> ou se encontra sem permissão. </p>
                </div>
                <div className="mt-4 d-flex gap-2 align-items-center justify-content-center">
                  <a href="#" className="btn btn-primary-dark rounded-3 px-4" >voltar ao início</a>
                  <a href="#" className="btn bg-white text-primary-dark rounded-3 px-4" >solicitar permissão</a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ErrorPermissionDenied;
